PegasusTemplate.DropVoidMixin = Ember.Mixin.create({
  dragEnter: function(e,header) {
    var $dropTarget = $('.show-drop-zone');
    if($dropTarget.length){
      if((e.target.className === 'container') && !header){
        return false;
      }
      Ember.View.views[$dropTarget.attr('id')].get('controller').send('unSelect');
    }
  }
});
